<template>
  <div class="flex flex-wrap justify-end">
    <div class="flex flex-wrap w-11/12 mb-8 text-gray-500">
      <div v-if="typeof(totalMonth) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-blue-900 h-3 w-3 rounded-full inline-block mr-2"></div>
        Agendamentos do mês
      </div>
      <div v-if="typeof(totalDay) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-green-700 h-3 w-3 rounded-full inline-block mr-2"></div>
        Agendamentos no dia
      </div>
      <div v-if="typeof(totalInProgress) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-gray-400 h-3 w-3 rounded-full inline-block mr-2"></div>
        Atendimentos em aberto
      </div>
      <div v-if="typeof(totalCompleted) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-sky-500 h-3 w-3 rounded-full inline-block mr-2"></div>
        Atendimentos já realizados
      </div>
      <div v-if="typeof(totalNotCompleted) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-orange-700 h-3 w-3 rounded-full inline-block mr-2"></div>
        Atendimentos não realizados
      </div>
      <div v-if="typeof(totalReschedule) == 'number'" class="flex items-center mb-4 w-full lg:w-1/2">
        <div class="bg-emerald-400 h-3 w-3 rounded-full inline-block mr-2"></div>
        Número de reagendamentos
      </div>
    </div>
  </div>
  <div v-if="typeof(totalMonth) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalMonth }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-blue-900 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalMonth) }"></div>
      </div>
    </div>
  </div>
  <div v-if="typeof(totalDay) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalDay }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-green-700 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalDay) }"></div>
      </div>
    </div>
  </div>
  <div v-if="typeof(totalInProgress) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalInProgress }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-gray-400 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalInProgress) }"></div>
      </div>
    </div>
  </div>
  <div v-if="typeof(totalCompleted) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalCompleted }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-sky-500 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalCompleted) }"></div>
      </div>
    </div>
  </div>
  <div v-if="typeof(totalNotCompleted) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalNotCompleted }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-orange-700 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalNotCompleted) }"></div>
      </div>
    </div>
  </div>
  <div v-if="typeof(totalReschedule) == 'number'" class="w-full mb-8">
    <div class="flex flex-wrap items-end">
      <div class="w-2/12 pr-4 text-sm text-right text-gray-500 h-4">
        {{ totalReschedule }}
      </div>
      <div class="flex items-end w-10/12 bg-gray-200 h-[2px]">
        <div class="bg-emerald-400 h-4 rounded-sm" :style="{ 'width': getFunctionPercentage(totalReschedule) }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  props: {
    totalDay: {
      type: [Number, Boolean],
      default: false,
    },
    totalMonth: {
      type: [Number, Boolean],
      default: false,
    },
    totalInProgress: {
      type: [Number, Boolean],
      default: false,
    },
    totalCompleted: {
      type: [Number, Boolean],
      default: false,
    },
    totalNotCompleted: {
      type: [Number, Boolean],
      default: false,
    },
    totalReschedule: {
      type: [Number, Boolean],
      default: false,
    },
  },
  methods: {
    getFunctionPercentage(value) {
      let max = this.getMax();
      let percentage = Math.round((value * 100) / max);
      return percentage + '%';
    },
    getMax() {
      let max = Math.max(this.totalDay, this.totalMonth, this.totalInProgress, this.totalCompleted, this.totalNotCompleted);
      max += Math.ceil(max * 0.20);
      return max;
    }
  },
}
</script>
<style>

</style>
